export const passwordConstraintContent: {
  id: number
  name: string
  message: string
}[] = [
  {
    id: 1,
    name: 'length',
    message: 'Must be at least 12 characters long',
  },
  {
    id: 2,
    name: 'lowercase',
    message: 'Must contain at least one lowercase letter',
  },
  {
    id: 3,
    name: 'uppercase',
    message: 'Must contain at least one uppercase letter',
  },
  {
    id: 4,
    name: 'number',
    message: 'Must contain at least one number',
  },
  {
    id: 5,
    name: 'special',
    message: 'Must contain at least one special character',
  },
]

export const getMatchedPasswordCriteria = (password: string): string[] => {
  const updatedCriteria: string[] = []

  // Check if the password value is empty
  if (!password || password.trim() === '') {
    return []
  }

  // Add "length" to criteria if the value's length is at least 12
  if (/^.{12,}$/.test(password)) {
    updatedCriteria.push('length')
  }

  // Add "number" to criteria if the value contains a number
  if (/\d/.test(password)) {
    updatedCriteria.push('number')
  }

  // Add "lowercase" to criteria if the value contains a lowercase letter
  if (/[a-z]/.test(password)) {
    updatedCriteria.push('lowercase')
  }

  // Add "uppercase" to criteria if the value contains an uppercase letter
  if (/[A-Z]/.test(password)) {
    updatedCriteria.push('uppercase')
  }

  // Add "special" to criteria if the value contains a special character
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    updatedCriteria.push('special')
  }

  return updatedCriteria
}
